export default __webpack_public_path__ + "static/media/BEACH_SAND_BG.a19e907b.jpg";